/** angular */
import { Injectable } from '@angular/core';
/** end angular */

/** rxjs */
import { Observable } from 'rxjs';
/** end rxjs */

/** services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** end services */

/** models */
import { DsFormsExportResponse } from '../models/ds-forms-export-response.class';
/** end models */

/** interfaces */
import { DsFormsExportResponseInterface } from '../interfaces/forms-export/ds-forms-export-response.interface';
/** end interfaces */

/** Sixense */
import { BydGenerateParams } from '@sixense/byd-core-service';
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class DsFormPdfExportService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Start the pdf generation on the back-end, the result pdfs are received by mail.
   *
   * @param projectId Selected project id
   * @param instanceIds Instance ids for the generation
   * @param location Whether to export with the location
   * @param queryParams filter query params.
   * @param linear Whether to call the linear export
   * @returns Observable<DsFormsExportResponse>
   */
  public startFormInstancePdfExports(
    projectId: number,
    instanceIds: number[],
    location: boolean,
    queryParams: Params,
    linear?: boolean
  ): Observable<DsFormsExportResponse> {
    this.path = `/v1/${linear ? `dslinear` : `dsform`}/projects/${projectId}/instances/pdfexport`;
    const params = BydGenerateParams({ ...queryParams, exportwithlocation: `${location}` });

    return this.postModel<DsFormsExportResponse>({ body: { instanceIds, reportName: queryParams.reportName }, params });
  }

  /**
   * Create DsFormsExportResponse instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsFormsExportResponse` instance.
   */
  public createNewInstance(jsonObject: DsFormsExportResponseInterface) {
    return new DsFormsExportResponse(jsonObject);
  }
}
